module.exports = __webpack_public_path__ + "img/chensansu.ca80c5a6.png";